import React from "react"

const NetworkSettingsContext = React.createContext({})

const { Provider, Consumer } = NetworkSettingsContext

export { Provider, Consumer, NetworkSettingsContext }
